export const toCents = (reaisStr) => {
    if (reaisStr == null) return 0;
    const normalized = reaisStr.toString().replace(/\./g, '').replace(',', '.');
    const value = Number.parseFloat(normalized || '0');
    return Math.round(value * 100);
};
